import Barra from './Barra';
export default Barra;